export interface KeyDateRequest {
    gSongNotesEntryID?: number;
    gSongNotes: string;
    gSongNotesAmount?: number;
    gSongNoteType: KeyDateTypes;
    gSongNoteSequence: number;
}

export interface KeyDateResponse {
    gSongNotesEntryID: number;
    gProjectId: number;
    gSongRef: string;
    gSongNoteEntryDate: null | string;
    gSongNoteType: KeyDateTypes;
    gSongNoteSequence: number;
    gSongNotes: string;
    gSongNotesOther: string;
    gSongNotesAmount: number;
}

export interface SongAssetsResponse {
    gSongAssetsID: number;
    gProjectId: number;
    gSongRef: string;
    gAssetFileName: string;
    gAssetVersion: string;
}

export interface SongTags {
    gSongRef: string;
    gSongFileName: string;
    gSongFilePath: string;
    gSongSoundTags: string;
    gSongArtworkTags: string;
}

export interface NewSongStepFiveData {
    keyDates: KeyDateRequest[];
}

export enum KeyDateTypes {
    MASTER = 1,
    RETENTION,
    AUDIT,
    OPTION,
    GENERAL,
    OTHER,
}

export enum KeySongPage {
    Songs,
    Synch,
    Stateuses,
    DSPs,
}

export const LabelStepSong = ['Song', 'Publishing', 'Recording', 'Assets', 'Track', 'Classify'];
export const LabelStepMoney = ['Reference', 'Payment', 'Royalties', 'Licensing', 'Recoups', 'Reconcile'];
export const LabelStepDeal = ['Deal', 'Rights', 'Parties', 'Payments', 'Dates', 'Rates', 'Signed'];

export const SynchSelect = ['Genre', 'Context', 'Mood', 'Era'];
